export const ActionTypes = {
  FETCH_JOB_TITLES_SEARCHED: 'services/job_titles/fetch_job_titles_searched',
  SET_JOB_TITLES_SEARCHED: 'services/job_titles/set_job_titles_searched',
  ADD_UPDATE_JOB_TITLES: 'services/job_titles/add_update_job_titles',
  DELETE_JOB_TITLES: 'services/job_titles/delete_job_titles',
  SET_JOB_TITLES_SEARCHED_LOADER_STATUS: 'services/job_titles/set_job_titles_searched_loader_status',
};
// Job title
const fetchjobTitlesSearched = ({ jobTitlesParams }) => ({
  jobTitlesParams,
  type: ActionTypes.FETCH_JOB_TITLES_SEARCHED,
});

const setjobTitlesSearched = ({ jobTitlesSearchedData }) => ({
  jobTitlesSearchedData,
  type: ActionTypes.SET_JOB_TITLES_SEARCHED,
});

const addUpdatejobTitles = ({ actionName, labourJobTitle, jobTitlesParams }) => ({
  actionName,
  labourJobTitle,
  jobTitlesParams,
  type: ActionTypes.ADD_UPDATE_JOB_TITLES,
});

const deletejobTitles = ({ jobTitlesId, jobTitlesParams }) => ({
  jobTitlesId,
  jobTitlesParams,
  type: ActionTypes.DELETE_JOB_TITLES,
});

const setjobTitlesSearchedLoader = ({ jobTitlesSearchedLoader }) => ({
  jobTitlesSearchedLoader,
  type: ActionTypes.SET_JOB_TITLES_SEARCHED_LOADER_STATUS,
});

export default {
  fetchjobTitlesSearched,
  setjobTitlesSearched,
  setjobTitlesSearchedLoader,
  addUpdatejobTitles,
  deletejobTitles,
};
